import { CalendarIcon, UsersIcon } from "@heroicons/react/24/outline";
import Button from "common/components/Button/Button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Status from "common/components/Status/Status";
import TooltipWrapper from "common/components/TooltipWrapper/TooltipWrapper";
import dayjs from "dayjs";

function ServerItem({ item, onDelete, onNavigate }: any) {
  const { t } = useTranslation();

  const editLink = `/servers/edit/${item.id}`;

  const isExpired = !dayjs(item.validUntil).isAfter(dayjs(), "day");

  return (
    <div className="flex flex-wrap flex-row px-4 py-4 mt-2 w-full relative bg-white cursor-pointer rounded-lg border border-slate-150 transition-all">
      <Link to={editLink} className="flex-1">
        <div className="flex flex-col flex-1 justify-between lg:pl-4 lg:pr-6">
          <div className="flex flex-col lg:flex-row gap-3">
            <div className="flex-1 flex flex-col gap-2 pt-3 lg:py-0">
              <h4 className="text-xl font-bold text-primary leading-4 mb-1">
                {item.name}
              </h4>
            </div>
            <div className="flex items-center gap-1 text-sm mr-3">
              <UsersIcon className="w-3 h-3" />
              <span className="font-bold">{item.maxNbUsers}</span>
            </div>

            <div className="flex items-center gap-1 text-sm">
              <CalendarIcon className="w-3 h-3" />
              <span className="font-bold">
                {dayjs(item.validUntil).format("DD/MM/YYYY")}
              </span>
            </div>
          </div>
        </div>
      </Link>

      <div className="flex flex-col justify-between items-end text-xs lg:border-l pl-4 min-w-[22em] border-slate-150 gap-2">
        <div className="flex justify-end gap-2">
          <Status
            status={
              item.licenseKey ? (!isExpired ? "active" : "expired") : "inactive"
            }
          />
        </div>

        <div className="flex w-full items-center justify-end text-slate-500">
          <div>
            <div className="flex w-full gap-1">
              <TooltipWrapper content={<span>{t("actions.delete")}</span>}>
                <Button
                  type="error-line"
                  icon="TrashIcon"
                  compact
                  onClick={() => onDelete(item.id)}
                  confirmMessage={t("actions.confirmDelete")}
                />
              </TooltipWrapper>

              <Button
                title={t("actions.edit")}
                type="warning-line"
                icon="PencilSquareIcon"
                onClick={() => onNavigate(item.id)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServerItem;
